import { render, staticRenderFns } from "./classStatistic.vue?vue&type=template&id=72b4f8e6&scoped=true&"
import script from "./classStatistic.vue?vue&type=script&lang=js&"
export * from "./classStatistic.vue?vue&type=script&lang=js&"
import style0 from "./classStatistic.vue?vue&type=style&index=0&id=72b4f8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b4f8e6",
  null
  
)

export default component.exports